import React, { useState } from 'react';
import Input from './Input';
import Button from './Button';
import './WaitlistForm.css';
import GradualSpacingText from './GradualSpacingText/GradualSpacingText';

const WaitlistForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({ email: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [contactValue, setContactValue] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!formData.email.trim() && !formData.phone.trim()) {
      setError('Please provide an email or phone number so we can follow up.');
      setLoading(false);
      return;
    }

    // No Firebase: simulate submission and show success
    await new Promise((r) => setTimeout(r, 400));

    const contact = (formData.email || '').trim() || (formData.phone || '').trim() || '';
    setContactValue(contact);
    setFormData({ email: '', phone: '' });
    setSuccess(true);
    setLoading(false);

    if (onSuccess) onSuccess();
  };

  if (success) {
    return (
      <div className="waitlist-form success-message">
        <h3><GradualSpacingText text={"Thanks - we received your request"} spacing="0.02em" stagger={18} /></h3>
        <p>
          {contactValue
            ? `We will contact you at ${contactValue} to follow up on your request.`
            : `Thank you. We will follow up shortly.`}
        </p>
      </div>
    );
  }

  return (
    <form className="waitlist-form" onSubmit={handleSubmit}>
      <h2 className="form-headline"><GradualSpacingText text={"Request a Quote / Contact Us"} spacing="0.03em" stagger={18} /></h2>
      <div className="form-fields">
        <Input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
        />

        <Input
          type="tel"
          name="phone"
          placeholder="Phone"
          value={formData.phone}
          onChange={handleChange}
        />
      </div>
      <div className="hint">We’ll review your request and get back to you promptly.</div>
      {error && <div className="error-message">{error}</div>}
      <Button type="submit" disabled={loading}>
        {loading ? 'Sending...' : 'Request Quote'}
      </Button>
      <p className="trust-line">By contacting us you agree to our terms. We’ll only use your contact for follow-up.</p>
    </form>
  );
};

export default WaitlistForm;

